import type { ReactNode } from 'react';
import { MetricCard } from '../ui/MetricCard';

// Story 2-147ta judgment call, recorded here and in SESSION-HANDOFF.md: this
// stays module-scoped in `components/dashboard` (P10 §2.7 row 5's own
// `2-147d` rule-of-three investigation already settled that — NOT
// re-litigated by this story) but now composes the new canonical
// `MetricCard` (`components/ui`) internally instead of re-deriving its
// `rounded-hairline border border-border bg-card` wrapper by hand — the
// exact locally-recreated card contract this story's own done-when measures
// against. Zero API/behaviour change for `DashboardPage.tsx` (this file's
// only consumer): same props, same rendered result, minus the arbitrary
// `bg-white/40 dark:bg-white/10` icon-badge colour (never a real semantic
// token — replaced by `MetricCard`'s own `bg-muted` role) and minus the
// `hover:-translate-y-0.5 hover:shadow-lg` micro-interaction, which was
// this file's own decoration, not part of the card CONTRACT — dropped as
// dead weight now that the wrapper is shared, not carried forward as
// unreviewed debt.
interface KpiCardProps {
  title: string;
  value: string;
  delta?: string;
  icon?: ReactNode;
  trendLabel?: string;
  'data-testid'?: string;
}

export function KpiCard({ title, value, delta, icon, trendLabel, 'data-testid': testId }: KpiCardProps): JSX.Element {
  return (
    <MetricCard
      label={title}
      value={value}
      {...(delta ? { delta } : {})}
      {...(icon ? { icon } : {})}
      {...(trendLabel ? { trendLabel } : {})}
      {...(testId ? { 'data-testid': testId } : {})}
    />
  );
}
